import React from 'react';

import { namePartsToFirstLastInitial } from '../../../utils';
import { TextCell, TextCellProps } from '../CellPatterns';

export interface UserCellUser {
  avatar_url?: string | null;
  first?: string | null;
  last?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
}

interface Props extends Pick<TextCellProps, 'align' | 'href'> {
  user: UserCellUser;
  nameFormat: 'initials' | 'full';
  /** When true, show the user's email below the name (if present). Default false. */
  showEmail?: boolean;
}

const UserCell: React.FC<Props> = ({ user, nameFormat, showEmail = false, align, href }) => {
  const first = user.first ?? user.firstname ?? '';
  const last = user.last ?? user.lastname ?? '';
  const avatarUrl = user.avatar_url ?? undefined;
  const email = user.email ?? undefined;

  const displayName =
    nameFormat === 'initials'
      ? namePartsToFirstLastInitial({ firstname: first, lastname: last })
      : `${first} ${last}`.trim() || '—';

  const supportingText = showEmail && email ? email : null;

  return (
    <TextCell value={displayName} avatarUrl={avatarUrl} supportingText={supportingText} align={align} href={href} />
  );
};

export default UserCell;
